import React from 'react';
import { Box, Modal, Typography, Button } from '@mui/material';
import { Mail, PencilLine } from 'lucide-react';
import { TOKENS } from '../state/colors';
import { fs } from '../state/typography';
import { useIconScale } from '../state/useIconScale';
import { BolsaCentro } from '../types';

interface ChannelChoiceModalProps {
  bolsa: BolsaCentro;
  onCerrar: () => void;
  onElegirCorreo: () => void;
  onElegirManual: () => void;
}

// SPEC-180 UC-001/RN-001 — siempre se pregunta el canal antes de transicionar a ENVIADA
export const ChannelChoiceModal: React.FC<ChannelChoiceModalProps> = ({
  bolsa,
  onCerrar,
  onElegirCorreo,
  onElegirManual,
}) => {
  const iconSize = useIconScale(18);

  return (
    <Modal open onClose={onCerrar} data-testid="channel-choice-modal">
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          maxWidth: '92vw',
          backgroundColor: '#fff',
          borderRadius: '20px',
          padding: '30px 32px',
          boxShadow: '0 24px 60px rgba(46,36,48,.28)',
        }}
      >
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(11), fontWeight: 600, letterSpacing: '2.2px', textTransform: 'uppercase', color: TOKENS.muted, marginBottom: '6px' }}>
          MARCAR COMO ENVIADA
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(19), fontWeight: 700, color: TOKENS.ink, marginBottom: '18px' }}>
          {bolsa.codigo_cotizacion ?? bolsa.id}
        </Typography>

        <Box
          data-testid="channel-choice-correo"
          onClick={onElegirCorreo}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 14px',
            border: `1px solid ${TOKENS.hair}`,
            borderRadius: '14px',
            cursor: 'pointer',
            marginBottom: '10px',
            '&:hover': { backgroundColor: TOKENS.wash },
          }}
        >
          <Box sx={{ width: 38, height: 38, borderRadius: '11px', backgroundColor: 'rgba(147,64,143,.10)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Mail size={iconSize} color={TOKENS.purple} />
          </Box>
          <Box>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(14), fontWeight: 600, color: TOKENS.ink }}>
              Enviar por correo
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(11.5), color: TOKENS.muted }}>
              Genera versión, PDF y envía por SMTP.
            </Typography>
          </Box>
        </Box>

        <Box
          data-testid="channel-choice-manual"
          onClick={onElegirManual}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 14px',
            border: `1px solid ${TOKENS.hair}`,
            borderRadius: '14px',
            cursor: 'pointer',
            marginBottom: '20px',
            '&:hover': { backgroundColor: TOKENS.wash },
          }}
        >
          <Box sx={{ width: 38, height: 38, borderRadius: '11px', backgroundColor: 'rgba(147,64,143,.10)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <PencilLine size={iconSize} color={TOKENS.purple} />
          </Box>
          <Box>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(14), fontWeight: 600, color: TOKENS.ink }}>
              Marcar como enviada manualmente
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(11.5), color: TOKENS.muted }}>
              Ya se envió por fuera del sistema (WhatsApp, llamada, en persona).
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onCerrar} sx={{ textTransform: 'none', fontFamily: 'Poppins, sans-serif', border: `1px solid ${TOKENS.hair}`, color: TOKENS.text }}>
            Cancelar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
